import { Component, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwMessage, DwMessageSeverity, DwRoutingService, DwSecurityState, DwSecurityStateService } from '@devwareapps/devware-cap';
import IntegrationUtilService from '../../../integration/services/integration-util.service';
import { PaymentsRepositoryService } from '../../../payments/services/payments-repository.service';
import { StripeSessionDetailsResult } from 'c:/Projects/DevwareGit/AviatorOnline/AviatorOnlineCAPAngular/src/app/features/payments/models/stripe-session-details-result.model';

@DwComponent({
  key: 'aviatorLogin',
  name: 'Aviator Login Page',
  componentType: DwComponentType.pageComponent,
  isGlobal: true
})
@Component({
  selector: 'app-aviator-login-page',
  templateUrl: './aviator-login-page.component.html',
  styleUrls: ['./aviator-login-page.component.scss']
})
export class AviatorLoginPageComponent implements OnInit {
 
  topMessage: DwMessage;
  logoutMessageShown: boolean = false;
  stripeSessionDetails: StripeSessionDetailsResult;

  loading: boolean = true;

  loadingMessage: string = "loading...";;

  constructor(protected integrationUtilService: IntegrationUtilService,
    protected dwSecurityStateService: DwSecurityStateService,
    protected paymentsRepositoryService: PaymentsRepositoryService,
    protected dwRoutingService: DwRoutingService
  ) { }

  ngOnInit(): void {
    const fspToken = this.integrationUtilService.getIntegrationTokenDetails();

    if (fspToken) {
      this.topMessage = {
        messageBody: 'Login or Sign up to complete FSP integration',
        severity: DwMessageSeverity.info,
      }
    }

    const stripeToken = this.integrationUtilService.getStripeToken();

    this.dwSecurityStateService.securityStateObservable
      .subscribe(value => {
        this.handleSecurityChange(value);
      });

    this.handleSecurityChange(this.dwSecurityStateService.securityState);

    if (stripeToken) {
      // this.topMessage = {
      //   messageBody: 'Login or Sign up to access your new course',
      //   severity: DwMessageSeverity.info,
      // }

      this.loadStripeSession(stripeToken);
    } else {
      this.loading = false;
    }

  }

  private loadStripeSession(stripeToken: string) {
    this.loadingMessage = "Completing Purchase...";

    this.paymentsRepositoryService.getStripeSessionDetails(stripeToken)
      .subscribe(stripeSessionDetails => {
        this.loading= false;
        this.stripeSessionDetails = stripeSessionDetails;
        this.setupStripeSession(stripeSessionDetails);
      })
  }

  setupStripeSession(stripeSessionDetails: StripeSessionDetailsResult) {
    this.stripeSessionDetails = stripeSessionDetails;

    if (!stripeSessionDetails) {
      return;
    }

    if (stripeSessionDetails.IsExistingUser) {
      this.topMessage = {
        messageBody: `Purchase Complete!  Login with your existing account to access ${stripeSessionDetails.Products}`,
        severity: DwMessageSeverity.info,
      }
    } else {
      this.topMessage = {
        messageBody: `Purchase Complete!  Login or Sign up to access ${stripeSessionDetails.Products}`,
        severity: DwMessageSeverity.info,
      }
    }

  }



  private handleSecurityChange(securityState: DwSecurityState) {

    if (securityState.inactivityLogoutComplete && !this.logoutMessageShown) {
      //this.dwSecurityStateService.setInactivityDetails(false, false, null);

      this.logoutMessageShown = true;


      this.topMessage = {
        severity: DwMessageSeverity.warning,
        messageBody: securityState.inactivityLogoutMessage,
        allowClose: true,
      }
    }
  }


}
